import { render, staticRenderFns } from "./main-notice-list.vue?vue&type=template&id=c4c9586a&scoped=true&"
import script from "./main-notice-list.vue?vue&type=script&lang=js&"
export * from "./main-notice-list.vue?vue&type=script&lang=js&"
import style0 from "./main-notice-list.vue?vue&type=style&index=0&id=c4c9586a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c9586a",
  null
  
)

export default component.exports